import {Component, inject} from '@angular/core';
import {DbActiveModal} from "../../../../../../../modules/modal/modal-ref";

@Component({
    selector: 'db-custom-domain-success-modal',
    templateUrl: './custom-domain-success-modal.component.html',
    styleUrl: './custom-domain-success-modal.component.scss',
    standalone: false
})
export class CustomDomainSuccessModalComponent {
  domain = '10web.me'
  clientUrl = 'websitename.'
  activeService = inject(DbActiveModal);
}
